import { MapAssignedUnitInfo } from '@mark43/cad-api';
import { Divider, VStack, Box, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { EventAssignedUnitOverview } from './event-assigned-unit-overview';
import { CommonSize, getOneSizeSmaller } from '../../../../common/helpers/utils';

type EventAssignedUnitsSectionProps = {
    assignedUnits?: MapAssignedUnitInfo[];
    size?: CommonSize;
};

export const EventAssignedUnitsSection = observer(function EventAssignedUnitsSection({
    assignedUnits,
    size,
}: EventAssignedUnitsSectionProps): React.ReactElement {
    const smallerSize = getOneSizeSmaller(size);

    return (
        <Box data-testid="MAP_LEDGER_EVENT_PANEL_ASSIGNED_UNITS_SECTION">
            <VStack alignItems="start" padding="12px 18px" spacing={3}>
                <Text fontSize={smallerSize} fontWeight="bold">
                    Assigned
                </Text>
                {assignedUnits?.map((unit) => {
                    return (
                        <EventAssignedUnitOverview key={unit.entityId} unit={unit} size={size} />
                    );
                })}
            </VStack>
            <Divider />
        </Box>
    );
});
